import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { EditFormSubmissionViewTopBar } from "./TopBar"

export const editFormSubmissionViewStaticData: StaticDataRouteOption = {
	leftSlideOut: AppNavigation,
	topBar: EditFormSubmissionViewTopBar,
}
